// eslint-disable-next-line import/prefer-default-export
export const recommendedFieldName = 'recommended';

export const currentPriceFieldName = 'currentPrice';

export const manufacturerFieldName = 'manufacturer';

export const modelFieldName = 'model';

export const ageFieldName = 'age';

export const registrationYearFieldName = 'registrationYear';

export const efficiencyFieldName = 'efficiency';

export const odometerFieldName = 'odometer';

export const createdAtFieldName = 'createdAt';

export const financesFromFieldName = 'financesFrom';

export const distanceFieldName = 'distance';

export const stockFieldName = 'createdAt';

export const ascDirection = 'asc';

export const descDirection = 'desc';

export const distanceUnitKm = 'km';

export const minFinancesPaymentFieldName = 'minFinancesPayment';

export const monthlyPaymentFieldName = 'financesFrom';

export const sortParamDefaultValue = {
  fieldName: currentPriceFieldName,
  direction: ascDirection,
};

export const sortDistanceOptionValue = {
  fieldName: distanceFieldName,
  direction: ascDirection,
};

export const availableOrderDirections = [ascDirection, descDirection];

export const availableOrderFieldNames = [
  recommendedFieldName,
  currentPriceFieldName,
  manufacturerFieldName,
  modelFieldName,
  ageFieldName,
  registrationYearFieldName,
  efficiencyFieldName,
  odometerFieldName,
  createdAtFieldName,
  financesFromFieldName,
  distanceFieldName,
  stockFieldName,
  distanceUnitKm,
  minFinancesPaymentFieldName,
  monthlyPaymentFieldName,
];
